"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    formatPhoneNumber: function() {
        return formatPhoneNumber;
    },
    isE164Format: function() {
        return isE164Format;
    },
    stripPhoneNumber: function() {
        return stripPhoneNumber;
    },
    toE164Format: function() {
        return toE164Format;
    }
});
const _validation = require("../utils/validation");
function formatPhoneNumber(input) {
    if (!(0, _validation.isNonEmptyString)(input)) return '';
    let parsedInput = input.replace(/[^0-9]+/g, '');
    const parts = [];
    let countryCode = '';
    if (parsedInput.length > 10) {
        // Extract the country code from the input (assuming it's at the beginning)
        countryCode = parsedInput.slice(0, parsedInput.length - 10);
        parsedInput = parsedInput.slice(-10);
    }
    if (countryCode) {
        parts.push(`+${countryCode} `);
    }
    if (parsedInput.length > 0) {
        parts.push('(');
        parts.push(parsedInput.slice(0, 3));
    }
    if (parsedInput.length > 3) {
        parts.push(') ');
        parts.push(parsedInput.slice(3, 6));
    }
    if (parsedInput.length > 6) {
        parts.push('-');
        parts.push(parsedInput.slice(6, 10));
    }
    return parts.join('');
}
const toE164Format = (phoneNumberString, countryCode = '+1')=>{
    if (!phoneNumberString || typeof phoneNumberString !== 'string') {
        return '';
    }
    const numericPhoneNumber = phoneNumberString.replace(/\D/g, '');
    // If the input has no country code, add the default country code
    const formattedNumber = countryCode === '' || numericPhoneNumber.startsWith(countryCode) ? `+${numericPhoneNumber}` : `${countryCode}${numericPhoneNumber}`;
    return formattedNumber;
};
const isE164Format = (phoneNumberString)=>{
    return /^\+[1-9]\d{1,14}$/.test(phoneNumberString);
};
const stripPhoneNumber = (phoneNumber, keepPlus = false)=>{
    const num = phoneNumber == null ? void 0 : phoneNumber.toString();
    if (!num || !(0, _validation.isNonEmptyString)(num)) return '';
    const regex = keepPlus ? /[^\d+]+/g : /[^\d]+/g;
    const res = num.replace(regex, '');
    if (res === '+') return '';
    return res;
};
const _default = formatPhoneNumber;

//# sourceMappingURL=phone.js.map